import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Facebook, Linkedin } from 'lucide-react';
import { useI18n } from '../i18n';
import { company } from '../mock';

const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="bg-black text-white/80 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 text-white">
            <div className="h-14 w-14 rounded-full overflow-hidden bg-black">
              <img
                src="https://customer-assets.emergentagent.com/job_ha-transport/artifacts/7sk20ayj_IMG_7956.png"
                alt="Ha Transport"
                className="h-full w-full object-cover scale-110"
              />
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-serif text-2xl">Ha Transport</span>
              <span className="text-[10px] tracking-[0.3em] uppercase text-white/60">Roissy CDG</span>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/60">{t('footer.tagline')}</p>
          <div className="flex items-center gap-3 mt-6 text-white/60">
            <a href="#" className="hover:text-white"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="hover:text-white"><Facebook className="w-4 h-4" /></a>
            <a href="#" className="hover:text-white"><Linkedin className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-white text-sm tracking-[0.2em] uppercase mb-5">{t('footer.services')}</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/services" className="hover:text-white">Berline VIP</Link></li>
            <li><Link to="/services" className="hover:text-white">Mercedes Classe V</Link></li>
            <li><Link to="/services" className="hover:text-white">Van Sprinter</Link></li>
            <li><Link to="/services" className="hover:text-white">Minibus & Autocar</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm tracking-[0.2em] uppercase mb-5">{t('footer.company')}</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-white">{t('nav.about')}</Link></li>
            <li><Link to="/excursions" className="hover:text-white">{t('nav.excursions')}</Link></li>
            <li><Link to="/business" className="hover:text-white">{t('nav.business')}</Link></li>
            <li><Link to="/cities" className="hover:text-white">{t('nav.cities')}</Link></li>
            <li><Link to="/contact" className="hover:text-white">{t('nav.contact')}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm tracking-[0.2em] uppercase mb-5">{t('footer.contact')}</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /> {company.address}</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> <a href={`tel:${company.phone.replace(/\s/g, '')}`} className="hover:text-white">{company.phone}</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> <a href={`mailto:${company.email}`} className="hover:text-white">{company.email}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Ha Transport. {t('footer.rights')}</p>
          <div className="flex items-center gap-6">
            <Link to="/mentions-legales" className="hover:text-white">{t('footer.legal')}</Link>
            <Link to="/cgv" className="hover:text-white">{t('footer.cgv')}</Link>
            <Link to="/confidentialite" className="hover:text-white">{t('footer.privacy')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
